import License from './License';

export * from './License';
export default License;
